import { ModalController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contestation-modal',
  templateUrl: './contestation-modal.component.html',
  styleUrls: ['./contestation-modal.component.scss'],
})
export class ContestationModalComponent implements OnInit {
  public contestationForm: FormGroup;

  get surveyContestationDescription() {
    return this.contestationForm.get('surveyContestationDescription');
  }

  constructor(private formBuilder: FormBuilder, private modalController: ModalController) {}

  ngOnInit() {
    this.contestationForm = this.initializeForm();
  }

  initializeForm() {
    return this.formBuilder.group({
      surveyContestationDescription: ['', Validators.compose([Validators.required])],
    });
  }

  cancel() {
    this.modalController.dismiss();
  }

  submit() {
    this.modalController.dismiss({ surveyContestationDescription: this.surveyContestationDescription.value });
  }
}
